export default __webpack_public_path__ + "static/realization-4-bf90cc18fbd509c2db6b42b281038aa8.jpg";